function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import withRouter from 'shared/helper/with-router';
import Redirect from 'shared/components/Redirect';
import { T, useTranslate } from 'shared/helper/translate';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
var ReworkSuccess = function ReworkSuccess(_ref) {
  var _match$params, _reworkData$files;
  var match = _ref.match;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var reworkData = JSON.parse(atob(decodeURIComponent(match === null || match === void 0 || (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.data))) || {};
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    redirect = _useState2[0],
    setRedirect = _useState2[1];
  var handleClose = function handleClose() {
    setRedirect({
      to: '/',
      push: true
    });
  };
  if (redirect) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: redirect.to,
      push: redirect.push
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container touchup new-button-styles"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "Re-edit Request Success"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8 col-12"
  }, /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement(T, {
    source: "Re-edit Request Success"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "Success! We have received your files:"
  }), /*#__PURE__*/React.createElement("ul", null, (_reworkData$files = reworkData.files) === null || _reworkData$files === void 0 ? void 0 : _reworkData$files.map(function (file) {
    return /*#__PURE__*/React.createElement("li", {
      key: file.identity
    }, file.name);
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "free-reedit-success-message"
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleClose,
    className: "btn btn-primary btn-squared",
    "aria-label": t('Close')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Close"
  })))));
};
export default withRouter(ReworkSuccess);